const FEATURE_HELP_URLS = {
  agent_bots: 'https://inexistent.com/hc/agent-bots',
  agents: 'https://inexistent.com/hc/agents',
  audit_logs: 'https://inexistent.com/hc/audit-logs',
  campaigns: 'https://inexistent.com/hc/campaigns',
  canned_responses: 'https://inexistent.com/hc/canned',
  channel_email: 'https://inexistent.com/hc/email',
  channel_facebook: 'https://inexistent.com/hc/fb',
  custom_attributes: 'https://inexistent.com/hc/custom-attributes',
  dashboard_apps: 'https://inexistent.com/hc/dashboard-apps',
  help_center: 'https://inexistent.com/hc/help-center',
  inboxes: 'https://inexistent.com/hc/inboxes',
  integrations: 'https://inexistent.com/hc/integrations',
  labels: 'https://inexistent.com/hc/labels',
  macros: 'https://inexistent.com/hc/macros',
  message_reply_to: 'https://inexistent.com/hc/reply-to',
  reports: 'https://inexistent.com/hc/reports',
  sla: 'https://inexistent.com/hc/sla',
  team_management: 'https://inexistent.com/hc/teams',
  webhook: 'https://inexistent.com/hc/webhooks',
  billing: 'https://inexistent.com/pricing',
  saml: 'https://inexistent.com/hc/saml',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
